export const TEACHING_THE_UNIT_ROUTE_PREFIX = 'teaching-the-unit'

export const DWB_TRAINING_COURSE_CODE_BY_BAND = {
  'k-5': 'k-5_dwb-training_tier-1_educator',
  '6-8': '6-8_dwb-training_tier-1_educator',
  '9-12': '9-12_dwb-training_tier-1_educator',
}

export const DWB_TRAINING_COURSE_CODES = new Set(
  Object.values(DWB_TRAINING_COURSE_CODE_BY_BAND),
)

export const extractTrainingRouteBand = route => {
  if (typeof route !== 'string' || !route.trim()) return null

  const normalizedRoute = route.trim().replace(/^\/+/, '')
  const slug = normalizedRoute.split('/').pop() || normalizedRoute

  if (!slug.startsWith(TEACHING_THE_UNIT_ROUTE_PREFIX)) return null

  const band = slug
    .slice(TEACHING_THE_UNIT_ROUTE_PREFIX.length)
    .replace(/^-/, '')
  return band || null
}

export const resolveDwbTrainingCourseCodeFromRoute = (
  route,
  contentGroupCode,
) => {
  const normalizedContentGroupCode = String(
    contentGroupCode || '',
  ).toLowerCase()
  if (normalizedContentGroupCode !== 'dwb') return null

  const routeBand = extractTrainingRouteBand(route)
  if (!routeBand) return null

  return DWB_TRAINING_COURSE_CODE_BY_BAND[routeBand] || null
}

export const isDwbTrainingCourseCode = courseCode =>
  DWB_TRAINING_COURSE_CODES.has(String(courseCode || ''))
